import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { addRouteToHistory } from '../services/reducers/ui.slice';

export const RouteHistoryProvider = ({ children }: { children: React.ReactNode }) => {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    dispatch(addRouteToHistory(location.pathname));
  }, [location, dispatch]);

  return <>{children}</>;
};
